import { styled, Flex, Box } from '@acko-tech/building-blocks.ui.common'

export const RootContainer = styled(Box)`
  box-sizing: border-box;
  margin-top: 20px;
`

export const TabBarContainer = styled(Flex)`
  margin-left: ${props => (props.isFloater ? '20px' : 0)};

  @media screen and (max-width: 936px) {
    justify-content: center;
    margin-left: 0;
  }
`

export const ProductContentContainer = styled(Box)`
  @media screen and (max-width: 936px) {
    display: flex;
    justify-content: center;
  }
`

export const StyleBox = styled(Box)`
  width: ${props => (props.isWidget ? '100%' : 'unset')};
  max-width: ${props => (props.isWidget ? props.maxWidthPurple : 'unset')};
`
